import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageDelivery: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPackageDelivery"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H7.5V13.575C8.96935 13.8733 10.1267 15.0307 10.425 16.5H21V18H10.425C10.0775 19.7117 8.56422 21 6.75 21C4.67893 21 3 19.3211 3 17.25C3 15.4358 4.28832 13.9225 6 13.575V4.5H3V3ZM6.75 15C5.50736 15 4.5 16.0074 4.5 17.25C4.5 18.4926 5.50736 19.5 6.75 19.5C7.99264 19.5 9 18.4926 9 17.25C9 16.0074 7.99264 15 6.75 15Z" fill="currentColor"/><Path d="M14.75 4H10V14H21V4H16.25V9H14.75V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageDelivery;
